export default function createSubjectViewState(composeId, operation, subject, newContent) {
    return {
        selectionStart: -1,
        selectionEnd: -1,
        inputId: 'subjectLine' + composeId,
    };
}
//# sourceMappingURL=createSubjectViewState.js.map